import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ribe',
} as IModuleProps;
